module.exports = __webpack_public_path__ + "img/5-1.dc9034b3.png";